import { render, staticRenderFns } from "./student-headcount.vue?vue&type=template&id=320f5c3c&"
import script from "./student-headcount.vue?vue&type=script&lang=js&"
export * from "./student-headcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports